import React from 'react';
import Icon from '../../icon/index';
import { SearchResultContext } from '../context/SearchResultContext';
import Select from '../../select/Select';
import { trackSearchEvent } from '../api/request';
import NoResults from './NoResults';

const Commerce = (props) => {

    const { results, sortOrder, setSortOrder, language, endpoint } = React.useContext(SearchResultContext);

    if (results.items.length <= 0) return <NoResults heading={props.noResultsHeading} preamble={props.noResultsPreamble} query={props.query} />;

    return (
        <>
            <div className='search-result-block'>
                <div className='h-display-flex h-justify-content-end'>
                    <Select label={`${props.sortByLabel}`} options={props.sortOptions.map(i => ({ value: i.sortOrder, label: i.displayName }))} value={sortOrder} onChange={(e) => {
                        setSortOrder(e.target.value);
                    }} />
                </div>
                <div className='row'>
                    {results.items.map((item) => {
                        return (
                            <div className="col col--span-12 col--span-xs-6 col--span-l-4 col--span-xl-3 col--bottom-gutter-large">
                                <div className='card card--image card--bordered card--product'>
                                    <a className="card__cta" href={item.url} onClick={() => trackSearchEvent(language, endpoint, results.query, item.hitId)}>
                                        <figure className="card__figure">
                                            <img src={props.endpoint + item.imageUrl} className="card__image" />
                                        </figure>
                                        <div className="card__body">
                                            <span className="card__follow-link">
                                                <Icon icon="chevron-right" />
                                            </span>
                                            <h4 className="card__title">{item.title}</h4>
                                            <p className="card__description h-truncate-3">{item.description}...</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        );

                    })}
                </div>
            </div>
        </>
    );

};

export default Commerce;
